// extracted by mini-css-extract-plugin
export default {"wrapper":"dashboard-charts_wrapper__Gyvyi","block":"dashboard-charts_block__7NqKR","dataWrapper":"dashboard-charts_dataWrapper__jahMn","lastInfo":"dashboard-charts_lastInfo__JC9aG"};